export default {
    SET_LIMIT_ORDERS(state, payload) {
        state.limitOrders = payload;
    },
    SET_VOUCHER_LIMITS(state, payload) {
        state.voucherLimits = payload;
    },
};
